import Register from "../page/register/Register";
import AuthConsumer from "../../../context/auth/AuthConsumer";

export default function RegisterHOC({ ...props }) {
  return (
    <AuthConsumer>
      {({ ...rest }) => {
        return <Register {...props} {...rest} />;
      }}
    </AuthConsumer>
  );
}
